export default "__VITE_ASSET__81d2c69f__"